<app-select-input *ngIf="showMediaDisplay == true" [(ngModel)]="entity.mediaDisplay" label="Media Position" [options]="[
        {value: 1, displayValue: 'Header & Body Only'},
        {value: 2, displayValue: 'Media On Left'},
        {value: 3, displayValue: 'Media Full Width At Top'},
        {value: 4, displayValue: 'Use Custom Blocks Only'},
        ]" [required]="true" errorDisplay="inline"></app-select-input>


<app-instruction margin="20px 0 0" *ngIf="entity.mediaDisplay == MediaDisplay.CustomBlocksOnly">When using Custom
  Blocks Only, content specified for this {{PageType[entity.pgType]}} on the '{{contentTabName}}' tab won't be
  displayed. All content will need to be added in Custom Blocks in the Page Builder under the 'Layout' tab.
</app-instruction>

<ng-container *ngIf="entity.mediaDisplay == MediaDisplay.HalfWidth || entity.mediaDisplay == MediaDisplay.FullWidth">
  <app-select-input [(ngModel)]="entity.useVid" label="Media Type" [options]="mediaOptions"
    [includeNullOption]="true"></app-select-input>

  <ng-container *ngIf="entity.useVid == false">

    <ng-container *ngIf="entity.mediaDisplay == MediaDisplay.HalfWidth">
      <p>
        For media on left, we recommend square images.
      </p>

      <app-select-input [(ngModel)]="entity.cfgObj.vertPos" label="Vertical Placement of Content" [options]="[
        {value: 'flex-start', displayValue: 'Top'},
        {value: 'center', displayValue: 'Middle'},
        {value: 'flex-end', displayValue: 'Bottom'},
        ]" [required]="true" errorDisplay="inline" (ionChange)="updConfig()"></app-select-input>

      <!-- Caps the height of image slider so some max view height-->
      <app-select-input [(ngModel)]="entity.cfgObj.minHeight" label="Image Height" [options]="[
        {value: '10vh', displayValue: '10% View Height'},
        {value: '20vh', displayValue: '20% View Height'},
        {value: '30vh', displayValue: '30% View Height'},
        {value: '40vh', displayValue: '40% View Height'},
        {value: '50vh', displayValue: '50% View Height'},
        {value: '60vh', displayValue: '60% View Height'},
        {value: '70vh', displayValue: '70% View Height'},
        {value: '80vh', displayValue: '80% View Height'},
        {value: '90vh', displayValue: '90% View Height'},
        {value: '100vh', displayValue: 'Full Height'},
        ]" style="width: 250px;" [includeNullOption]="true" (ionChange)="updConfig()"></app-select-input>

      <app-select-input [(ngModel)]="entity.imgAnchor" label="Image Anchor" [options]="[
        {value: 'center', displayValue: 'Center'},
        {value: 'top', displayValue: 'Top'},
        {value: 'bottom', displayValue: 'Bottom'},
        ]" style="width: 250px; margin-right: 25px;" [includeNullOption]="true"
        sublabel="If image doesn't fit, where does it NOT crop from"></app-select-input>

      <ion-item>
        <ion-label position="stacked" style="padding-bottom: 7px;">Image Width: {{entity.cfgObj.imgWidth}}%</ion-label>
        <ion-range [(ngModel)]="entity.cfgObj.imgWidth" [min]="25" [max]="75" [pin]="true" (ionChange)="updConfig()"
          [pinFormatter]="pinFormatter"></ion-range>
      </ion-item>

    </ng-container>

    <ng-container *ngIf="entity.mediaDisplay == MediaDisplay.FullWidth">

      <p>
        For optimal rendering of banner images, select the aspect ratio below corresponding that of the image(s)
        you uploaded. On very wide screens a banner image can end up being taller than the screen, so you can
        set max height to restrict that behavior. When the max height comes into play, the 'anchor point' determines
        which part of the image is preserved or cut off.
      </p>
      <div class="flex-row two-col">
        <!-- Specifies the height of image slider using aspect ratio and width-->
        <app-select-input [(ngModel)]="entity.bannerRatio" label="Banner Aspect Ratio" [options]="[
          {value: 'calc(100vw)', displayValue: 'Square (i.e. 1200 x 1200)'},
          {value: 'calc(100vw / 4 * 3)', displayValue: 'Classic TV Format (i.e. 1200 x 900)'},
          {value: 'calc(100vw / 16 * 9)', displayValue: 'Widescreen Format (i.e. 1200 x 675)'},
          {value: 'calc(100vw / 2 * 1)', displayValue: 'Wide Banner  (i.e. 1200 x 600)'},
          {value: 'calc(100vw / 3 * 1)', displayValue: 'Really Wide Banner  (i.e. 1200 x 400)'},
          ]" [includeNullOption]="true" (onValueSelected)="calcPreviewHeights()"></app-select-input>

        <!-- Caps the height of image slider so some max view height-->
        <app-select-input [(ngModel)]="entity.bannerMaxH" label="Banner Max Height" [options]="[
          {value: '10vh', displayValue: '10% View Height'},
          {value: '20vh', displayValue: '20% View Height'},
          {value: '30vh', displayValue: '30% View Height'},
          {value: '40vh', displayValue: '40% View Height'},
          {value: '50vh', displayValue: '50% View Height'},
          {value: '60vh', displayValue: '60% View Height'},
          {value: '70vh', displayValue: '70% View Height'},
          {value: '80vh', displayValue: '80% View Height'},
          {value: '90vh', displayValue: '90% View Height'},
          {value: '100vh', displayValue: 'Full Height'},
          ]" [includeNullOption]="true" (onValueSelected)="calcPreviewHeights()"></app-select-input>
      </div>

      <app-select-input [(ngModel)]="entity.imgAnchor" label="Image Anchor" [options]="[
        {value: 'center', displayValue: 'Center'},
        {value: 'top', displayValue: 'Top'},
        {value: 'bottom', displayValue: 'Bottom'},
        ]" style="width: 250px; margin-right: 25px;" [includeNullOption]="true"
        sublabel="If image doesn't fit, where does it NOT crop from"></app-select-input>

    </ng-container>

    <p *ngIf="entity.mediaDisplay == MediaDisplay.FullWidth">Use the banner preview below to visualize how your
      configuration
      will cause the first image to render on different widths of screens. </p>

    <div class="flex-w">
      <!-- Image selection and list -->
      <div class="cbs-item" style="max-width: 400px;margin-right:25px;">
        <div class="cbs-item-label lbl-sort">
          <span>Images</span>
          <div class="sort flex-c">
            <span>Sort:</span>
            <ion-toggle [(ngModel)]="sortMode"></ion-toggle>
          </div>
        </div>

        <ng-container *ngIf="sortMode == false">
          <div syle="margin-bottom: 15px;">
            <app-image-preview *ngFor="let img of images; let idx = index;" margin="5px" height="250px" [imgPath]="img"
              [index]="idx" (removeImage)="remove(idx)"></app-image-preview>
            <app-add-image [someObject]="entity" imgProperty="imagePaths" (imageChanged)="parseImgUrls()"
              *ngIf="images.length < 5" [includeLibraryButton]="true" [maxImages]="5" height="250px" width="270px"
              [sizeRecommendation]="entity.mediaDisplay == MediaDisplay.FullWidth ? '1200px x 600px' : '600px x 600px'"></app-add-image>
          </div>
        </ng-container>

        <ng-container *ngIf="sortMode == true">
          <p>Drag images up/down to re-order</p>
          <div cdkDropList (cdkDropListDropped)="onDrop($event)">
            <div cdkDrag *ngFor="let img of images; let idx = index;">
              <app-image-preview margin="5px" height="250px" [imgPath]="img" [index]="idx"
                (removeImage)="remove(idx)"></app-image-preview>
            </div>
          </div>
          <app-add-image [someObject]="entity" imgProperty="imagePaths" (imageChanged)="parseImgUrls()"
            *ngIf="images.length < 5" [includeLibraryButton]="true" [maxImages]="5" height="250px"
            width="270px"></app-add-image>
        </ng-container>
      </div>

      <!-- Banner Preview to the right-->
      <div class="banner-preview" *ngIf="entity.mediaDisplay == MediaDisplay.FullWidth">
        <div class="cbs-item" style="max-width: 400px;margin-right:25px;">
          <div class="cbs-item-label">
            <h3>Banner Preview</h3>
          </div>
          <div class="flex">
            <div id="banner-preview">
              <div class="banner" [style.height]="previewBannerHeight" [style.max-height]="previewBannerMaxHeight">
                <img *ngIf="images.length > 0" [src]="images[0]" [style.object-position]="entity.imgAnchor">
              </div>
            </div>
            <div style="margin-left: 10px;">
              <ion-button *ngIf="showing == false" size="small" (click)="showScaling()">Show Sizing
                Behavior</ion-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="entity.useVid == true">
    <app-text-input [(ngModel)]="entity.videoUrl" label="Video URL" (checkingValidity)="videoUrlEntered()"
      [spellcheck]="false"></app-text-input>

    <div class="cbs-item ">
      <div class="cbs-item-label">
        Video Preview
      </div>
      <div class="cbs-item-sub-label">
        If the video URL is a correct embeddable URL, your video will preview here.
      </div>
      <div id="vid-preview">
        <iframe width="560" height="315" id="video" *ngIf="vidUrlSani != null" [src]="vidUrlSani" frameborder="0"
          allowfullscreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
      </div>
    </div>
  </ng-container>
</ng-container>